module.exports = __webpack_public_path__ + "static/media/banner2.c8345969.png";